var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2549 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2549 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_349)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5147 14.3922C32.5205 13.4757 30.4257 12.8311 28.2604 12.4585C27.9884 12.9419 27.6762 13.5865 27.4647 14.1001C25.1685 13.7577 22.8319 13.7577 20.5356 14.1001C20.2939 13.5361 20.0119 12.9923 19.7098 12.4585C17.5445 12.8211 15.4395 13.4757 13.4555 14.4023C9.50753 20.2839 8.43997 26.0246 8.97375 31.6847C11.2902 33.4069 13.8886 34.7162 16.6481 35.5521C17.2725 34.7061 17.8164 33.8198 18.2897 32.8832C17.3934 32.5508 16.5273 32.1379 15.7014 31.6444C15.9129 31.4833 16.1244 31.3221 16.3258 31.1509C21.1802 33.4472 26.8101 33.4472 31.6745 31.1509C31.876 31.3221 32.0975 31.4833 32.309 31.6444C31.4832 32.1379 30.6171 32.5508 29.7207 32.8832C30.1941 33.8097 30.748 34.7061 31.3623 35.542C34.1219 34.7061 36.7203 33.3968 39.0367 31.6746C39.6511 25.1283 37.949 19.4279 34.5147 14.3922ZM18.9645 28.2C17.4639 28.2 16.2453 26.8303 16.2453 25.1484C16.2453 23.4665 17.4437 22.0867 18.9645 22.0867C20.4853 22.0867 21.7039 23.4564 21.6939 25.1383C21.6737 26.8303 20.4853 28.2 18.9645 28.2ZM29.0359 28.2C27.5352 28.2 26.3166 26.8303 26.3166 25.1484C26.3166 23.4665 27.5151 22.0867 29.0359 22.0867C30.5566 22.0867 31.7753 23.4564 31.7551 25.1383C31.735 26.8303 30.5566 28.2 29.0359 28.2Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_349",
    x1: 7.02687,
    y1: 7.03221,
    x2: 40.9701,
    y2: 40.9755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5865F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7084,
    stopColor: "#651EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A00DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.0a0c7c7949b15fab747b48f41b844a99.svg";
export { ForwardRef as ReactComponent };